import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

export const CONDO_TOWNHOME_HOMEOWNER = 'condo / townhome homeowner';
export const DOWNSIZER = 'downsizer';
export const FIRST_TIME_BUYER = 'first-time buyer';
export const HOMEOWNER = 'homeowner';
export const MILITARY = 'military';
export const MOTIVATED_SELLER = 'motivated seller';
export const MULTI_GENERATIONAL = 'multi-generational';
export const REAL_ESTATE_INVESTOR = 'real estate investor';
export const RELOCATION = 'relocation';
export const RENTER = 'renter';
export const REPEAT_HOMEBUYER = 'repeat homebuyer';
export const SECONDARY_RESIDENCE = 'secondary residence';
export const SINGLE_FAMILY_HOMEOWNER = 'single family homeowner';

export const AGENT_CONTACT_TYPES = {
    CONDO_TOWNHOME_HOMEOWNER,
    DOWNSIZER,
    FIRST_TIME_BUYER,
    HOMEOWNER,
    MILITARY,
    MOTIVATED_SELLER,
    MULTI_GENERATIONAL,
    REAL_ESTATE_INVESTOR,
    RELOCATION,
    RENTER,
    REPEAT_HOMEBUYER,
    SECONDARY_RESIDENCE,
    SINGLE_FAMILY_HOMEOWNER,
}

class LuAgentContactTypeAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'lu-agent-contact-type';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'lus/agents/contacts/types';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'created_at',
            'updated_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'title',
            'slug',
            'userUuid'
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {};
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {};
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            title: {
                type: 'string',
                presence: true,
            },
            slug: {
                type: 'string',
            },
            userUuid: {
                type: 'string',
                presence: true,
            },
        };
    }

}

export default LuAgentContactTypeAppResource;
